// API configuration - use relative URLs since frontend and backend are on same domain
const API_BASE_URL = '';  // Empty string means same domain

export const API_ENDPOINTS = {
  contact: `${API_BASE_URL}/api/contact`,
  chat: `${API_BASE_URL}/api/chat`,
  chatSuggestions: `${API_BASE_URL}/api/chat/suggestions`,
  chatHealth: `${API_BASE_URL}/api/chat/health`,
  contactHealth: `${API_BASE_URL}/api/contact/health`
};

export default API_BASE_URL;
